import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
} from '@angular/forms';
import { MatLegacyCheckbox as MatCheckbox } from '@angular/material/legacy-checkbox';

@Component({
  selector: 'checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss'],
})
export class CheckboxComponent implements OnInit {
  formGroup: UntypedFormGroup;

  private static defaultTrueVerification: () => boolean = () => {
    return true;
  };

  @ViewChild(MatCheckbox, { static: true })
  private matCheckbox: MatCheckbox;

  @Input()
  public checked = false;
  @Input()
  public text: string;
  @Input()
  public title: string;
  @Input()
  public subtitle: string;
  @Input()
  public isDisabled: boolean;
  @Input()
  public boldText: boolean;
  @Input()
  public trueVerification: () => boolean =
    CheckboxComponent.defaultTrueVerification;

  @Output()
  public answer = new EventEmitter();

  constructor(private formBuilder: UntypedFormBuilder) {}

  ngOnInit() {
    this.formGroup = this.initForm();
  }

  initForm() {
    return this.formBuilder.group({
      answer: new UntypedFormControl(''),
    });
  }

  answered(value) {
    if (value && !this.trueVerification()) {
      this.checked = false;
      this.matCheckbox.checked = false;
      return;
    }
    this.answer.emit(value);
  }
}
